export function ProductSkeleton() {
  return (
    <div className="bg-white border border-border rounded-xl overflow-hidden">
      <div className="aspect-square skeleton" />
      <div className="p-3 space-y-2">
        <div className="h-3 w-12 skeleton rounded" />
        <div className="h-4 w-full skeleton rounded" />
        <div className="h-4 w-2/3 skeleton rounded" />
        <div className="h-10 w-full skeleton rounded-full mt-3" />
      </div>
    </div>
  );
}

export function CategorySkeleton() {
  return (
    <div className="flex flex-col items-center gap-2 p-2">
      <div className="w-14 h-14 md:w-16 md:h-16 rounded-full skeleton" />
      <div className="h-3 w-12 skeleton rounded" />
    </div>
  );
}

export function CartItemSkeleton() {
  return (
    <div className="flex items-center gap-3 p-3 bg-white rounded-xl border border-border">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg skeleton" />
      <div className="flex-1 space-y-2">
        <div className="h-4 w-3/4 skeleton rounded" />
        <div className="h-3 w-1/4 skeleton rounded" />
        <div className="h-4 w-1/3 skeleton rounded" />
      </div>
      <div className="h-8 w-24 skeleton rounded-full" />
    </div>
  );
}
